import { userService } from '../_services'
import { router } from '../_helpers'
import { tokenParse, tokenValid } from '../_helpers/auth-header'

const tokens = JSON.parse(localStorage.getItem('tokens'))
const userUuid = localStorage.getItem('user_uuid')
const tokenData = tokens ? tokenParse(tokens.access_token) : null
const tokenExp = tokenData ? tokenData.exp : null
const tokenRole = tokenData ? tokenData.role : null
const state = tokens ? {
  status: {
    loggedIn: true
  },
  tokens,
  tokenExp,
  tokenRole,
  userUuid,
  profile: null,
  avatars: [],
  loginData: null,
  registerData: null,
  wallet: -1,
  balanceHistory: []
} : {
  status: {},
  tokens: null,
  tokenExp: null,
  tokenRole: null,
  userUuid: null,
  profile: null,
  avatars: [],
  loginData: null,
  registerData: null,
  wallet: -1,
  balanceHistory: []
}

var avatarClearIntervalId = -1

const getters = {
  userUuid (state) {
    return state.userUuid
  },
  userRole (state) {
    return state.tokenRole
  },
  walletCredit (state) {
    if (state.wallet.hasOwnProperty('loading') || state.wallet.hasOwnProperty('error') || state.wallet < 0) {
      return 0
    }
    return state.wallet
  },
  walletCreditFetched (state) {
    if (state.wallet.hasOwnProperty('loading') || state.wallet.hasOwnProperty('error') || state.wallet !== -1) {
      return true
    }
    return false
  },
  isTokenActive (state) {
    if (!state.tokenExp) {
      return false
    }
    return tokenValid(state.tokenExp)
  }
}

const actions = {
  login ({ dispatch, commit }, { phone }) {
    commit('loginRequest', { phone })

    userService.login(phone)
      .then(
        response => {
          commit('loginSuccess')
          router.push('/verify')
        },
        error => {
          commit('loginFailure', error)
          dispatch('alert/error', error, { root: true })
        }
      )
  },
  checkShowLogin ({ commit }) {
    if (!state.tokens) {
      router.push('/login')
    } else {
      var decoded = tokenParse(state.tokens.access_token)
      if (!decoded || !tokenValid(decoded.exp) || decoded.sub.length === 0) {
        userService.logout()
        commit('logout')
        router.push('/login')
      }
    }
  },
  checkShowVerify ({ commit }) {
    if (!state.phone || (!state.status.registering && !state.status.loggingIn)) {
      router.push('/login')
    }
  },
  resendLoginOrRegister ({ commit, dispatch }) {
    if (state.registerData) {
      dispatch('register', state.registerData)
    } else if (state.loginData) {
      dispatch('login', state.loginData)
    }
  },
  clearLoginOrRegister ({ commit }) {
    state.registerData = null
    state.loginData = null
    router.push('/login')
  },
  logout ({ commit }) {
    // TODO implement logout api
    userService.logout()
    commit('logout')
  },
  register ({ dispatch, commit }, user) {
    commit('registerRequest', user)

    userService.register(user)
      .then(
        response => {
          commit('registerSuccess')
          router.push('/verify')
        },
        error => {
          commit('registerFailure', error)
          dispatch('alert/error', error, { root: true })
        }
      )
  },
  authenticate ({ dispatch, commit }, { code }) {
    commit('authenticateRequest', { code })

    userService.authenticate(state.phone, code)
      .then(
        response => {
          commit('authenticateSuccess', response)
        },
        error => {
          commit('authenticateFailure', error)
          dispatch('alert/error', error, { root: true })
        }
      )
  },
  profile ({ dispatch, commit }, userUuid) {
    commit('profileRequest')

    userService.profile(userUuid)
      .then(
        response => commit('profileSuccess', response),
        error => commit('profileFailure', error)
      )
  },
  avatar ({ dispatch, commit }, userUuid) {
    commit('avatarRequest')

    // search in the short memory avatar cache
    const userAvatar = state.avatars.filter(avatar => {
      if (avatar.userUuid === userUuid) {
        return true
      }
      return false
    })
    if (userAvatar.length > 0) {
      commit('avatarSuccess', {userUuid, response: userAvatar[0].avatar, exists: true})
      return
    }

    userService.avatar(userUuid)
      .then(
        response => commit('avatarSuccess', {userUuid, response, exists: false}),
        error => commit('avatarFailure', error)
      )
  },
  wallet ({ dispatch, commit }) {
    commit('walletRequest')

    userService.wallet()
      .then(
        response => commit('walletSuccess', response),
        error => commit('walletFailure', error)
      )
  },
  balanceHistory ({ dispatch, commit }) {
    commit('balanceHistoryRequest')

    userService.balanceHistory(0)
      .then(
        response => commit('balanceHistorySuccess', response),
        error => commit('balanceHistoryFailure', error)
      )
  }
}

const mutations = {
  loginRequest (state, { phone }) {
    state.status = { loggingIn: true }
    state.phone = phone
    state.loginData = { phone }
  },
  loginSuccess (state) {
    // state.status = {}
  },
  loginFailure (state) {
    state.status = {}
    state.phone = null
    state.tokens = null
    state.userUuid = null
    state.tokenExp = null
    state.tokenRole = null
    state.loginData = null
    state.registerData = null
    // remove tokens from local storage to log user out
    localStorage.removeItem('user_uuid')
    localStorage.removeItem('tokens')
  },
  logout (state) {
    state.status = {}
    state.phone = null
    state.tokens = null
    state.userUuid = null
    state.tokenExp = null
    state.tokenRole = null
    state.loginData = null
    state.registerData = null
    // remove tokens from local storage to log user out
    localStorage.removeItem('user_uuid')
    localStorage.removeItem('tokens')
  },
  registerRequest (state, user) {
    state.status = { registering: true }
    state.phone = user.phone
    state.registerData = { user }
  },
  registerSuccess (state) {
    // state.status = {}
  },
  registerFailure (state, error) {
    state.status = {}
    state.phone = null
    state.tokens = null
    state.userUuid = null
    state.tokenExp = null
    state.tokenRole = null
    state.loginData = null
    state.registerData = null
  },
  authenticateRequest (state) {
    state.status = { authenticating: true }
  },
  authenticateSuccess (state, response) {
    var decoded = tokenParse(response.access_token)
    if (decoded && tokenValid(decoded.exp) && decoded.sub.length > 0) {
      state.status = { loggedIn: true }
      state.tokens = response
      state.userUuid = decoded.sub
      state.tokenExp = decoded.exp
      state.tokenRole = decoded.role
      // store token
      localStorage.setItem('tokens', JSON.stringify(state.tokens))
      localStorage.setItem('user_uuid', state.userUuid)
    } else {
      state.status = {}
      state.phone = null
      state.tokens = null
      state.userUuid = null
      state.tokenExp = null
      state.tokenRole = null
      state.loginData = null
      state.registerData = null
      localStorage.removeItem('user_uuid')
      localStorage.removeItem('tokens')
    }
    router.push('/')
  },
  authenticateFailure (state) {
    state.status = {}
    state.phone = null
    state.tokens = null
    state.userUuid = null
    state.tokenExp = null
    state.tokenRole = null
    state.loginData = null
    state.registerData = null
  },
  profileRequest (state) {
    state.profile = { loading: true }
  },
  profileSuccess (state, profile) {
    state.profile = { item: profile }
    if (profile.uuid) {
      // store user profile
      localStorage.setItem(`prf_${profile.uuid}`, JSON.stringify(profile))
    }
  },
  profileFailure (state, error) {
    state.profile = { error: error }
  },
  walletRequest (state) {
    state.wallet = { loading: true }
  },
  walletSuccess (state, wallet) {
    state.wallet = wallet.balance
  },
  walletFailure (state, error) {
    state.wallet = { error: error }
  },
  balanceHistoryRequest (state) {
    state.balanceHistory = { loading: true }
  },
  balanceHistorySuccess (state, balanceHistory) {
    state.balanceHistory = { items: balanceHistory }
  },
  balanceHistoryFailure (state, error) {
    state.balanceHistory = { error: error }
  },
  avatarRequest (state) {
  },
  avatarSuccess (state, {userUuid, response, exists}) {
    if (!exists) {
      state.avatars.push({
        userUuid: userUuid,
        avatar: response,
        createdAt: Date.now()
      })
    }

    if (avatarClearIntervalId === -1) {
      avatarClearIntervalId = setInterval(() => {
        const now = Date.now()
        state.avatars = state.avatars.filter(avatar => {
          if (avatar.createdAt + 180000 < now) {
            return false
          }
          return true
        })
      }, 5000)
    }
  },
  avatarFailure (state, error) {
  }
}

export const account = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/_store/account.module.js